// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"InventoryItemDialog_subtitle_1RclO","switcher":"InventoryItemDialog_switcher_1I-V7"};